import React from 'react';
import { Moment } from 'moment';
import { TimePicker, TimePickerProps } from 'antd';

import styles from './time-picker.module.scss';

interface Props extends TimePickerProps {
	dataTestId?: string;
}

const TimePickerWrapper: React.FunctionComponent<Props> = (props: Props) => {
	const onChange = (date: Moment | null, formatString) => {
		const { value, onChange } = props;

		if (date && value) {
			date = value.clone().set({ hour: date.hour(), minute: date.minute(), second: date.second() });
		}

		onChange?.(date, formatString);
	};

	return (
		<TimePicker
			{...props}
			onChange={onChange}
			className={`bringg-picker ${props.className || ''}`}
			popupClassName={`bringg-picker-dropdown ${styles.timePicker} ${props.popupClassName}`}
			data-test-id={props.dataTestId || 'bringg-time-picker'}
		/>
	);
};

TimePickerWrapper.defaultProps = {
	format: 'h:mm a',
	use12Hours: true,
	className: 'time-picker-input'
};

export default TimePickerWrapper;
